/* The two silhouettes and their PRZÓD / TYŁ captions.
 *
 * `--h-silhouette` and `--silhouette-ring` are `shared/ui/bodyModel/BodySilhouette.module.css`'s own
 * hooks: the shared file states the geometry PROPERTY and this one states the value, which is the
 * split every shared stylesheet in this app uses. The ring is off — the canon draws the figures as
 * flat fills on three grey steps, and an outline would turn them into a diagram. */

.figures {
  display: inline-flex;
  gap: var(--space-9-5px);
}

.box {
  --h-silhouette: var(--h-ex-figure);
  --silhouette-ring: transparent;

  display: flex;
  flex-direction: column;
  gap: var(--space-4px);
  align-items: center;

  /* The box is TALLER than the figure by the caption and its gap, so the card's own reserve does
   * not move on the frame the caption's font lands. */
  height: var(--h-ex-figure-box);
}

/* The theatre's pair. One size hook rather than a second component: the fills and the artwork are
 * identical, and what differs is the height and the CAPTIONS — `kanon-02-teatr-*.png` draws none,
 * so the box is exactly the figure and there is no caption line to reserve. */
.theatre .box {
  --h-silhouette: var(--h-ex-theatre-figure);

  height: var(--h-ex-theatre-figure);
}

.caption {
  font-size: var(--fs-goal-lab);
  font-weight: var(--fw-bold);
  line-height: var(--lh-none);
  letter-spacing: var(--ls-group);
  text-transform: uppercase;
  color: var(--text-3);
}

/* The creator's pair, beside the chip grid on step 2 — KANON Cwiczenia 17.09.2026, variant g,
 * `kpFigs(d, 168)`. Captioned like the panel's, but at `--text-2`: the creator's round moved every
 * readable word off the tertiary ink (build spec rule 2), and `kp-figcap` says so. */
.creator {
  gap: var(--space-10px);
}

.creator .box {
  --h-silhouette: var(--h-ex-wizard-figure);

  gap: var(--space-5px);
  height: auto;
}

.creator .caption {
  font-size: var(--fs-micro-label);
  color: var(--text-2);
}
